import { render, staticRenderFns } from "./PriceInfoModal.vue?vue&type=template&id=d834ca66&scoped=true"
import script from "./PriceInfoModal.vue?vue&type=script&lang=ts"
export * from "./PriceInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./PriceInfoModal.vue?vue&type=style&index=0&id=d834ca66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d834ca66",
  null
  
)

export default component.exports